import { render, staticRenderFns } from "./sessions-per-date.vue?vue&type=template&id=2b781bf2&"
import script from "./sessions-per-date.vue?vue&type=script&lang=js&"
export * from "./sessions-per-date.vue?vue&type=script&lang=js&"
import style0 from "./sessions-per-date.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports